import React from "react";
import {Form, Input, Button, Card, Flex, message} from "antd";
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import {login} from "../Services";
import NoweZgloszenieLayaut from "../../noweZgloszenie/NoweZgloszenieLayaut";
import {useNavigate} from "react-router-dom";

const Login = () => {
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();

    const onFinish = (values: any) => {
        let dane = {
            login: values.login,
            pass: values.pass
        }

        login(dane).then((response) => {
            localStorage.setItem('sygnalistaTopUser', JSON.stringify({
                uzytkownik: response.data,
                credentials: "Basic " + btoa(dane.login + ":" + dane.pass)
            }))

            window.location.reload();
            // navigate('/admin');
        }).catch((error) => {
            // console.log('error', error.response.status);

            if(error.response.status === 401){
                messageApi.open({
                    type: 'error',
                    content: 'Złe dane logowania',
                    duration: 5,
                });
            } else {
                messageApi.open({
                    type: 'error',
                    content: 'Error',
                    duration: 5,
                });
            }

        })
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <NoweZgloszenieLayaut>
            <Flex justify={'center'}>
                <Card title="Logowanie" style={{ marginTop: '50px', width: 300, boxShadow: '3px 3px 3px #ddd' }}>
                    <Form
                        name="login_form"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="login"
                            rules={[{ required: true, message: 'Proszę podać nazwę użytkownika!' }]}
                        >
                            <Input prefix={<UserOutlined />} placeholder="Nazwa użytkownika" />
                        </Form.Item>

                        <Form.Item
                            name="pass"
                            rules={[{ required: true, message: 'Proszę podać hasło!' }]}
                        >
                            <Input.Password prefix={<LockOutlined />} placeholder="Hasło" />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" block>
                                Zaloguj się
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Flex>
            {contextHolder}
        </NoweZgloszenieLayaut>
    )
}

export default Login;
